import { render, staticRenderFns } from "./language.vue?vue&type=template&id=01d09c72"
import script from "./language.vue?vue&type=script&lang=js"
export * from "./language.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports